export default "__VITE_ASSET__9bee4f0a__"